import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/skincare/diagnostics"
    exact
    path="/business/showcase/skincare/diagnostics"
    component={AsyncPage}
  />,
  <ShowocaseLayout
    key="/business/showcase/skincare/live-diagnostics"
    exact
    path="/business/showcase/skincare/live-diagnostics"
    component={AsyncPage}
  />,
];
